'use client'

import React from 'react'

import type { SelectProps } from '~/core/ui/Select'
import { Select } from '~/core/ui/Select'

const MultipleSelect = (
  props: SelectProps & { ref?: React.Ref<HTMLSelectElement> }
) => {
  const { ref, ...rest } = props
  return (
    <Select
      ref={ref}
      {...rest}
      isMulti={true}
      hideSelectedOptions={false}
      closeMenuOnSelect={false}
    />
  )
}

MultipleSelect.displayName = 'MultipleSelect'

export { MultipleSelect }
